import { render, staticRenderFns } from "./PilihPaket.vue?vue&type=template&id=ee8bed8a&"
import script from "./PilihPaket.vue?vue&type=script&lang=js&"
export * from "./PilihPaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports